import React from "react";
import { Box, Drawer } from "@mui/material";
import Notifications from "../../../../Containers/Notifications";
// Desktop popover sizing: keep the panel fully inside the viewport so its
// header ("Notifications" + "Mark all as read") is always reachable.
const PANEL_MAX_HEIGHT = 717;
const VIEWPORT_MARGIN = 16;

function NotificationsContent({
  modalPosition,
  isBelowMd,
  notificationDrawerOpen,
  handleNotificationDrawerClose,
}) {
  const viewportHeight =
    typeof window !== "undefined" ? window.innerHeight : 900;
  // Cap the panel to whatever the viewport can actually show.
  const panelHeight = Math.min(
    PANEL_MAX_HEIGHT,
    viewportHeight - VIEWPORT_MARGIN * 2,
  );
  // The panel opens upward from the sidebar button; clamp so it never runs
  // off the top (header hidden) or the bottom of the screen.
  const desiredTop = (modalPosition?.top ?? 0) - 580;
  const maxTop = Math.max(
    VIEWPORT_MARGIN,
    viewportHeight - panelHeight - VIEWPORT_MARGIN,
  );
  const safeTop = Math.min(Math.max(desiredTop, VIEWPORT_MARGIN), maxTop);
  // Point the little arrow at the sidebar button, clamped inside the panel.
  const arrowTop = Math.min(
    Math.max((modalPosition?.top ?? 0) - safeTop - 12, 24),
    panelHeight - 24,
  );

  const webStyling = {
    position: "absolute",
    top: `${safeTop}px`,
    left: `280px`,
    bgcolor: "background.paper",
    maxHeight: `${PANEL_MAX_HEIGHT}px`,
    height: `${panelHeight}px`,
    borderRadius: "12px",
    minWidth: "248px",
    maxWidth: "629px",
    width: "100%",
    "&::before": {
      content: '""',
      position: "absolute",
      top: `${arrowTop}px`,
      left: "-16px",
      width: 0,
      height: 0,
      borderTop: "16px solid transparent",
      borderBottom: "16px solid transparent",
      borderRight: "16px solid white",
    },
  };

  return !isBelowMd ? (
    <Box sx={webStyling}>
      <Notifications
        isBelowMd={isBelowMd}
        handleNotificationDrawerClose={handleNotificationDrawerClose}
      />
    </Box>
  ) : (
    <Drawer
      anchor="right"
      open={notificationDrawerOpen}
      onClose={handleNotificationDrawerClose}
      PaperProps={{
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        },
      }}
    >
      <Notifications
        isBelowMd={isBelowMd}
        handleNotificationDrawerClose={handleNotificationDrawerClose}
      />
    </Drawer>
  );
}

export default NotificationsContent;
